<template>
    <div id="org_settings_users">
        <div class="card mb-3 table-card">
            <div class="card-header">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <h3 class="mt-2">Team Members ({{ filtered_users.length }})</h3>
                    </div>
                    <div class="col-lg-6 d-none d-md-block">
                        <div class="d-flex justify-content-end justify-self-end gap-2">
                            <div class="position-relative">
                                <input 
                                    type="text" 
                                    class="search-box form-control me-1 py-2" 
                                    placeholder="Search by Name..." 
                                    aria-label="Search by Name..." 
                                    v-model="search_key" 
                                    @input="filterUsers" 
                                    autocomplete="one-time-code"
                                >
                                <i 
                                    class="fa fa-search search-placeholder-icon" 
                                    v-show="!search_key"
                                ></i>
                            </div>
                            <a 
                                :href="addUserUrl()" 
                                class="btn btn-primary float-end"
                            >
                                <span>
                                    <i class="fas fa-fw fa-plus"></i>
                                    Add Team Member
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-width-responsive">
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                <th 
                                    @click="sortByKey('name')" 
                                    class="d-table-cell"
                                >
                                    <div class="d-flex flex-row">
                                        Name
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'name' && sort_order === 'asc' }" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'name' && sort_order === 'des' }" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th 
                                    @click="sortByKey('email')" 
                                    class="d-none d-md-table-cell"
                                >
                                    <div class="d-flex flex-row">
                                        Email
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'email' && sort_order === 'asc' }" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'email' && sort_order === 'des' }" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th 
                                    @click="sortByKey('user_type')" 
                                    class="d-none d-sm-table-cell"
                                >
                                    <div class="d-flex flex-row">
                                        User Type
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'user_type' && sort_order === 'asc' }" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'user_type' && sort_order === 'des' }" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th class="d-table-cell column-sort-disabled pe-3" width="1">
                                    <div class="d-flex flex-row">
                                        Action
                                    </div>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr 
                                v-for="(user, index) in list_shown" 
                                :key="user.id"
                                v-if="agency.users.length > 0"
                            >
                                <td class="d-table-cell">
                                    <img 
                                        class="avatar rounded-circle me-3" 
                                        :src="user.image" 
                                        alt="User avatar"
                                    />
                                    <a 
                                        :href="editUserUrl(user.id)" 
                                        data-bs-toggle="tooltip" 
                                        data-bs-placement="bottom" 
                                        title="Edit User"
                                    >
                                        {{ user.name }}
                                    </a>
                                </td>
                                <td class="d-none d-md-table-cell">
                                    {{ user.email }}
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    {{ propercase(user.user_type) }}
                                </td>
                                <td class="d-table-cell">
                                    <button 
                                        class="btn btn-none px-1" 
                                        @click="confirmDeleteUser(user)" 
                                        title="Delete User"
                                    >
                                        <img 
                                            class="icon red-icon" 
                                            src="/img/icons/avid-icons/trash.svg" 
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="bottom" 
                                            title="Delete User"
                                            alt="Delete icon"
                                        >
                                    </button>
                                </td>
                            </tr>
                            <tr v-else>
                                <td colspan="100%" class="text-center py-3">No team members found. <a :href="addUserUrl()">Create a new team member</a>.</td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select 
                                                    class="form-select" 
                                                    name="num_per_page" 
                                                    id="num_per_page" 
                                                    v-model="num_per_page" 
                                                    @change="reloadPagination(filtered_users)"
                                                 aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option 
                                                        v-for="num in num_per_page_options" 
                                                        :key="num" 
                                                        :value="num"
                                                    >
                                                        {{ num }}
                                                    </option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ filtered_users.length === 0 ? '0' : item_interval }} of {{ filtered_users.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button 
                                                v-if="page_count > 1" 
                                                class="btn btn-secondary btn-icon-only-md me-1" 
                                                @click="moveToPrevPage(filtered_users)" 
                                                :disabled="page_index === 0"
                                                data-bs-toggle="tooltip"
                                                title="Previous page"
                                            >
                                                <img 
                                                    class="icon" 
                                                    src="/img/icons/avid-icons/chevron-left.svg"
                                                    alt="Previous page"
                                                >
                                            </button>

                                            <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                <button 
                                                    v-for="page in page_index_array" 
                                                    :key="page" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    :class="{'current-page': page === page_index + 1}" 
                                                    @click="moveToPage(page, filtered_users)"
                                                >
                                                    {{page}}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-else>
                                                <button 
                                                    v-for="page in page_index_array.slice(0,2)" 
                                                    :key="page" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    :class="{'current-page': page === page_index + 1}" 
                                                    @click="moveToPage(page, filtered_users)"
                                                >
                                                    {{page}}
                                                </button>

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                ...
                                                </button>
                                                <button 
                                                    v-if="page_index >= 2 && page_index < page_index_array.length - 1" 
                                                    class="btn btn-none btn-icon-only-md current-page"
                                                >
                                                    {{page_index + 1}}
                                                </button>

                                                <button v-if="page_index < page_index_array.length - 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                ...
                                                </button>
                                                <button 
                                                    :class="{'current-page': page_index === page_index_array.length - 1}" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    @click="moveToPage(page_index_array.length, filtered_users)" 
                                                    :key="page_index_array.length"
                                                >
                                                    {{ page_index_array.length }}
                                                </button>
                                            </div>

                                            <button 
                                                v-if="page_count > 1" 
                                                class="btn btn-secondary btn-icon-only-md ms-1" 
                                                @click="moveToNextPage(filtered_users)" 
                                                :disabled="page_index === page_count - 1"
                                                data-bs-toggle="tooltip"
                                                title="Next page"
                                            >
                                                <img 
                                                    class="icon" 
                                                    src="/img/icons/avid-icons/chevron-right.svg"
                                                    alt="Next page"
                                                >
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>                    
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { useNotifications } from '../../composables/useNotifications';
import tablePaginationMixin from '../../mixins/table_pagination';

export default defineComponent({
    name: 'AgencyUsers',
    props: {
        agency: {
            type: Object,
            required: true
        }
    },
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    mixins: [tablePaginationMixin],
    data() {
        return {
            filtered_users: [],
            list_shown: [],
            search_key: '',
            sort_key: null,
            sort_order: 'asc',
        };
    },
    mounted() {
        if(this.agency.users) {
            this.filtered_users = [...this.agency.users];
        }
        this.reloadPagination(this.filtered_users);

        // Initialize tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (let i = 0; i < tooltipTriggerList.length; i++) {
            (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                    tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                    tooltipList[index].hide();
                });
            })(i);
        }
    },
    methods: {
        filterUsers() {
            if (this.search_key.trim() === "") {
                this.filtered_users = [...this.agency.users];
            } else {
                const key = this.search_key.toLowerCase();
                this.filtered_users = this.agency.users.filter(user => user.name.toLowerCase().includes(key));
            }
            this.reloadPagination(this.filtered_users);
        },
        sortByKey(key) {
            if (this.sort_key === key) {
                this.sort_order = (this.sort_order === 'asc') ? 'des' : 'asc';
            } else {
                this.sort_key = key;
                this.sort_order = 'asc';
            }
            this.sortData();
        },
        sortData() {
            if (this.sort_order === 'asc') {
                this.filtered_users.sort((a, b) => a[this.sort_key].localeCompare(b[this.sort_key]));
            } else {
                this.filtered_users.sort((a, b) => b[this.sort_key].localeCompare(a[this.sort_key]));
            }
            this.reloadPagination(this.filtered_users);
        },
        confirmDeleteUser(user) {
            Swal.fire({
                title: `Are you sure you want to remove ${user.name}?`,
                text: "They will lose access to all dashboards and any communications from Avid.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, confirm",
                customClass: {
                    popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteUser(user);
                }
            });
        },
        deleteUser(user) {
            axios.delete(`/api/agencies/${this.agency.id}/users/${user.url}`)
                .then(response => {
                    // Remove user from the local list
                    const index = this.agency.users.findIndex(u => u.id === user.id);
                    if (index !== -1) {
                        this.agency.users.splice(index, 1);
                        this.filterUsers();
                    }
                    this.showNotification({
                        text: '<strong>' + user.name + '</strong> was removed!'
                    });
                })
                .catch(error => {
                    console.error('Error deleting user:', error);
                    this.showNotification({
                        text: 'Error removing this user. Please try again.',
                        type: 'error'
                    });
                });
        },
        addUserUrl() {
            return `/admin/agency/${this.agency.id}/user/add`;
        },
        editUserUrl(user_id) {
            return `/admin/agency/${this.agency.id}/user/${user_id}`;
        }
    }
});
</script>